<template>
<div>
  <div
    class="form-row"
    v-if="loaded"
  >
    <div
      class="col form-group input-group"
      v-if="!readonly"
    >
      <div
        class="input-group-prepend"
      >
        <div
          class="input-group-text"
        >
          <ItpIcon
            icon="material-symbols:calendar-month"
          >
          </ItpIcon>
        </div>
      </div>
      <ItpFormSelect
        name="selectedRuleID"
        v-model="selectedRuleID"
        :options="rules"
        valueField="id"
        textField="rule.description"
        :placeholder="'Select predefined rule to add.'|pgettext('BillingDateRule')"
      >
      </ItpFormSelect>
      <div
        class="input-group-append"
      >
        <ItpButton
          variant="light"
          icon="fa-plus"
          :tooltip="'Add rule configuration'|pgettext('BillingDateRule')"
          :disabled="!selectedRuleID"
          @click="evh_4207795475682514_click($event, {})"
        >
        </ItpButton>
      </div>
    </div>
  </div>
  <div
    class="form-row"
    v-if="loaded"
  >
    <div
      class="col-md-5 form-group"
    >
      <ItpFormSelect
        name="reference_month"
        v-model="item.reference_month"
        :options="referenceMonthOptions"
        valueField="value"
        textField="name"
        required
        :readonly="readonly"
      >
      </ItpFormSelect>
    </div>
    <div
      class="col-md-4 form-group"
    >
      <ItpFormSelect
        name="day_specifier"
        v-model="item.day_specifier"
        :options="daySpecifierOptions"
        valueField="value"
        textField="name"
        required
        :readonly="readonly"
      >
      </ItpFormSelect>
    </div>
    <div
      class="col-md-3 input-group form-group"
    >
      <ItpFormInput
        type="number"
        name="day_value"
        v-model="item.day_value"
        :readonly="readonly"
        ref="offsetDays"
      >
      </ItpFormInput>
      <DIV
        class="input-group-append"
      >
        <span
          class="input-group-text"
        >
          {{ 'day'|pgettext('InputGroupAddon') }}
        </span>
      </DIV>
    </div>
  </div>
  <div
    class="form-row"
    v-if="loaded"
  >
    <div
      class="col"
    >
      <ItpFormInput
        name="description"
        v-model="item.description"
        :placeholder="'Rule description'|pgettext('ExchangeRateDateRule')"
        :readonly="readonly"
      >
      </ItpFormInput>
    </div>
  </div>
</div>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class ExchangeRateDateRuleFields extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  addRule(...args: any[]) {
    const [id] = args;
    const obj = _.find(this.rules, { id });
    if (obj) {
      _.extend(this.item, obj.rule);
      this.setData('selectedRuleID', null);
    }
    this.$emit("input", this.item);
  }

  @Prop({
    type: Object,
  })
  value!: object;

  @Watch('value')
  onValue(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("value")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  item!: any;

  async $$load_item() {
    return this.value || {}
  }

  labelAlign!: any;
  rule_type!: any;
  rules!: any;

  async $$load_rules() {
    return this.$app.repo.get('list_object_by_type', { parameters: { object_type: 'billing-rule' } })
      .then(items => _.chain(items).filter({ rule_type: this.rule_type }).value())
  }

  metadata!: any;

  async $$load_metadata() {
    return this.$app.repo.get('ui_metadata')
  }

  selectedRuleID!: any;
  ux!: any;
  dataMembers = ['item', 'labelAlign', 'rule_type', 'rules', 'metadata', 'selectedRuleID', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        item: null,
        labelAlign: "right",
        rule_type: "exchange_rate_date",
        rules: null,
        metadata: null,
        selectedRuleID: null,
        ux: null,
      },
    }
  }

  get referenceMonthOptions() {
    if (this.loaded) {

      return this.metadata.exchange_rate_date_reference_month_options
    }
    return null;
  }

  get daySpecifierOptions() {
    if (this.loaded) {

      return this.metadata.exchange_rate_date_day_specifier_options
    }
    return null;
  }

  async act_4207795475682514_script_6704_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_4207795475682514_script_6704, alias=undefined
    this.addRule(this.selectedRuleID)
  }

  async act_4207795475682514_script_6704_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_4207795475682514_script_6704, alias=undefined
    return {
      value: () => this.act_4207795475682514_script_6704_getActionArgs_value($event),
    }
  }

  async evh_4207795475682514_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4207795475682514_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_4207795475682514_script_6704: actions.ScriptAction;
    evh_4207795475682514_click_6703: actions.EventHandlerImpl;
    evh_4207795475682514_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_4207795475682514_script_6704 = new actions.ScriptAction(
      {
        actionArgs: this.act_4207795475682514_script_6704_getActionArgs,
        events: [],
      }
    );
    const evh_4207795475682514_click_6703 = new actions.EventHandlerImpl(
      {
        action: act_4207795475682514_script_6704,
        event: "click",
        displayName: "script",
      }
    );
    const evh_4207795475682514_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_4207795475682514_click_6703],
      }
    );
    return {
      act_4207795475682514_script_6704,
      evh_4207795475682514_click_6703,
      evh_4207795475682514_click,
    }
  }
}

Vue.component("ExchangeRateDateRuleFields", ExchangeRateDateRuleFields);

</script>